export default "/fonts/vendor/katex/dist/KaTeX_Size4-Regular.woff?aeffd8025cba3647f1a6c07f222d985e";